module.exports = __webpack_public_path__ + "img/satellite.1700.0026c686.png";